import { IMtrChartRecord } from '@/dto/operationalPlanSummary';
import { OperationalDayName } from './OperationalDayName';

export class MtrRecord {

    public static fromDto(dto: IMtrChartRecord): MtrRecord {

        if (!dto) { throw new Error('dto is not set'); }

        const operDayName = OperationalDayName.fromDto(dto.operDayName);

        const result = new MtrRecord(operDayName,
                                     dto.weightByConsumptions,
                                     dto.countByConsumptions,
                                     dto.unitByConsumptions,
                                     dto.weightByRelocations,
                                     dto.countByRelocations,
                                     dto.unitByRelocations);

        return result;
    }

    public readonly operDayName: OperationalDayName;
    public readonly weightByConsumptions: number;
    public readonly countByConsumptions: number;
    public readonly unitByConsumptions: string;
    public readonly weightByRelocations: number;
    public readonly countByRelocations: number;
    public readonly unitByRelocations: string;

    constructor(operDayName: OperationalDayName,
                weightByConsumptions: number,
                countByConsumptions: number,
                unitByConsumptions: string,
                weightByRelocations: number,
                countByRelocations: number,
                unitByRelocations: string) {
        this.operDayName = operDayName;
        this.weightByConsumptions = weightByConsumptions;
        this.weightByRelocations = weightByRelocations;
        this.countByConsumptions = countByConsumptions;
        this.countByRelocations = countByRelocations;
        this.unitByConsumptions = unitByConsumptions;
        this.unitByRelocations = unitByRelocations;
    }

}
